import InviteCodeExpiredAndResent from './errors/InviteCodeExpiredAndResent'
import InviteCodeExpired from './errors/InviteCodeExpired'
import * as React from 'react'
import useInviteCodeErrors, { AuthError } from './useInviteCodeErrors'
import { useAppSelector } from '../../store/hooks'
import { selectAuthErrors } from '../../store/auth/authSlice'
import { UnexpectedError } from './errors/UnexpectedError'
import { LoginHeader } from './headers/LoginHeader'
import { SignupHeader } from './headers/SignupHeader'

export interface LoginErrorPanelProps {
  errorMessage: string
  errorCode: string | null
}

export const LoginErrorPanel = ({ errorMessage, errorCode }: LoginErrorPanelProps) => {
  const authErrors = useAppSelector(selectAuthErrors)
  const { isInviteCodeExpired, isInviteCodeResent } = useInviteCodeErrors(authErrors as AuthError[])

  if (isInviteCodeResent) {
    return (
      <div className='auth-container'>
        <SignupHeader hideAccountCreation />
        <InviteCodeExpiredAndResent />
      </div>
    )
  }

  if (isInviteCodeExpired) {
    return (
      <div className='auth-container'>
        <SignupHeader hideAccountCreation />
        <InviteCodeExpired />
      </div>
    )
  }

  return (
    <div className='auth-container'>
      <LoginHeader />
      <UnexpectedError errorMessage={errorMessage} errorCode={errorCode} />
    </div>
  )
}
